import styled from "styled-components";
import { Back } from "../components/button/Back";
import { ConsultantProfile } from "../components/ConsultantProfile";
import { LoggedInLayout } from "../components/layouts/LoggedInLayout";
import { PageTitle } from "../components/text/PageTitle";
import { Job } from "@models/Job";

interface JobApplicationsPageProps {
	applications?: Job["applications"];
}

const JobApplicationsPage = ({ applications }: JobApplicationsPageProps) => {
	return (
		<LoggedInLayout width="s">
			<Styles>
				<PageTitle>Ansökningar ({applications?.length || "0"})</PageTitle>
				<Back />

				<div className="ctn">
					{applications?.map((a) => <ConsultantProfile key={a.id} consultant={a.consultant} />)}
				</div>
			</Styles>
		</LoggedInLayout>
	);
};

export default JobApplicationsPage;

const Styles = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	.ctn {
		display: flex;
		align-items: space-around;
		justify-content: center;
		gap: 3rem;
		flex-wrap: wrap;
	}
`;
